enum OsType {
    Unknown = 0,

    // WinCe
    WinCeMin = 10000,
    WinCe = 10000,
    WinCeNet = 10001,
    WinCePocketPc = 10002,
    WinCeSmartphone = 10003,
    WinCeWindowsMobile = 10004,
    WinCeMax = 20000,

    // Win Desktop
    WindowsMin = 30000,
    Windows = 30000,
    Windows95 = 30001,
    Windows98 = 30002,
    WindowsMe = 30003,
    WindowsNt351 = 30004,
    WindowsNt4 = 30005,
    Windows2000 = 30006,
    WindowsXp = 30007,
    WindowsServer2003 = 30008,
    WindowsVista = 30009,
    Windows7 = 30010,
    WindowsServer2008 = 30011,
    Windows8 = 30012,
    WindowsServer2012 = 30013,
    Windows81 = 30014,
    Windows10 = 30015,
    WindowsServer2016 = 30016,
    WindowsMax = 39999,

    // Universal Windows
    UniversalWindows = 40000,

    // iOS
    IosMin = 70000,
    Ios = 70000,
    IosMax = 80000,

    // Android
    AndroidMin = 90000,
    Android = 90000,
    AndroidMax = 99999,

    LinuxMin = 100000,
    LinuxMax = 109999,

    TizenMin = 110000,
    TizenMax = 119999,

    OsMax = 120000
}

enum BatteryStatusAndroid {
    Unknown = 1,
    Charging = 2,
    Discharging = 3,
    NotCharging = 4,
    Full = 5
}

enum BatteryStatusWM {
    High = 1,
    Low = 2,
    Critical = 4,
    Charging = 8,
    NoBattery = 128,
    Unknown = 255
}

export class OsDetectionService {
    static IsAndroid = (osType: number = 0): boolean => {
        return (osType >= OsType.AndroidMin) && (osType <= OsType.AndroidMax);
    };
    static IsWindows = (osType: number = 0): boolean => {
        return (osType >= OsType.WindowsMin) && (osType <= OsType.WindowsMax);
    };
    static IsWindowsCe = (osType: number = 0): boolean => {
        return (osType >= OsType.WinCeMin) && (osType <= OsType.WinCeMax);
    };
    static IsUniversalWindows = (osType: number = 0): boolean => {
        return (osType == OsType.UniversalWindows);
    };
    static IsIOS = (osType: number = 0): boolean => {
        return (osType >= OsType.IosMin) && (osType <= OsType.IosMax);
    };
    static IsLinux = (osType: number = 0): boolean => {
        return (osType >= OsType.LinuxMin) && (osType <= OsType.LinuxMax);
    };
    static IsTizen = (osType: number = 0): boolean => {
        return (osType >= OsType.TizenMin) && (osType <= OsType.TizenMax);
    };
}

